export const hostnames = {
    prod: "spond.com",
    staging1: "staging1.spond.dev",
    dev1: "dev1.spond.dev",
};
